import * as React from "react";
export var SvgButton = function (_a) {
    var SvgComponent = _a.svg, name = _a.name, children = _a.children, onClick = _a.onClick, className = _a.className, disabled = _a.disabled;
    var disabledContainer = disabled ? "button-disabled__container" : "";
    var disabledContainerContent = disabled ? "button-disabled__container--content" : "";
    return (React.createElement("div", { className: name + "__container " + disabledContainer },
        React.createElement(SvgComponent, { className: "svg-button " + className, onClick: disabled ? undefined : onClick, disabled: disabled }),
        React.createElement("div", { className: name + "__container--content " + disabledContainerContent }, children)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/svg-button/SvgButton.tsx
// module id = 184
// module chunks = 3